import { Link, List, ListItem, Typography } from '@mui/material';
import { IRecentRequests } from 'API/UniversalRequest/universalRequest';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { useNavigate } from 'react-router-dom';

interface IPreAutocompleteContent {
  data?: IRecentRequests[];
  type?: string;
  handleSubCategoryClick?: (id: number) => void;
}

export const PreAutocompleteContent = ({
  data,
  type,
  handleSubCategoryClick,
}: IPreAutocompleteContent) => {
  const navigate = useNavigate();
  const dictionary = useDictionary(Dictionary, DICTIONARY.UniversalRequest);

  const output = (
    <>
      <Typography variant={'body8'}>
        {type === 'popular'
          ? dictionary.mayInterestYou
          : dictionary.recentRequests}
      </Typography>
      <List sx={{ gap: '16px', display: 'flex', flexDirection: 'column' }}>
        {data &&
          data.map((request) => (
            <ListItem
              tabIndex={0}
              sx={{ p: 0, cursor: 'pointer' }}
              key={request.id}
              onClick={() =>
                handleSubCategoryClick && handleSubCategoryClick(request.id)
              }
              onKeyUp={(e: React.KeyboardEvent) => {
                e.key === 'Enter' &&
                  handleSubCategoryClick &&
                  handleSubCategoryClick(request.id);
              }}
            >
              <Typography variant={'body3'}>{request.title}</Typography>
            </ListItem>
          ))}
      </List>
      {type === 'recent' && (
        <Link
          sx={{
            fontWeight: '600',
            borderTop: '1px solid #344266',
            paddingTop: '8px',
            marginTop: '8px',
            fontSize: '20px',
            color: '#081E54',
          }}
          component='button'
          onClick={() => navigate('/Applies')}
        >
          {dictionary.allRequests}
        </Link>
      )}
    </>
  );

  return output;
};
